import moment from "moment";
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate, useParams } from "react-router-dom";
import useSWR from "swr";
import NotFoundPage from "../../../../StoreComponents/NotFoundPage";
import { API } from "../../../../StoreComponents/conflict";

const fetcher = (url) =>
  API.get(url, {
    headers: {
      search: `%%`,
    },
  }).then((res) => res.data.data);
const MrrProductReceipt = () => {
  const { mrrsup_id } = useParams();
  //console.log(mrrsup_id);
  const [pageIndex, setPageIndex] = useState(0);
  // const [openElement, setOpenElement] = useState(false);
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(100);
  const navigate = useNavigate();
  const {
    data: productReceipt,
    error,
    mutate,
  } = useSWR(
    mrrsup_id
      ? `store/mrr/supplierMrr/${mrrsup_id}?page=${pageIndex}&limit=${limit}`
      : null,
    fetcher
  );

  console.log(productReceipt);

  // Search Implement
  const handleSearch = async (e) => {
    e.preventDefault();
    const search = e.target.value;
    setSearch(search);
    let limit = search === "" ? 10 : 1000;
    const res = await API.get(
      `store/mrr/supplierMrr/${mrrsup_id}?page=${0}&limit=${limit}`,
      {
        headers: {
          search: `%${search}%`,
        },
      }
    )
      .then((res) => res.data.data)
      .catch((error) => {
        if (error.name === "TypeError") {
          console.log("Data not found for the quary");
        }
      });
    if (res) {
      mutate(res, false);
    } else {
      mutate([], false);
    }
  };

  let counter = 1;
  return (
    <>
      <Helmet>
        <title>Product Entry Receipt - BBA STORE</title>
        <meta name="description" content="Product Entry Receipt - BBA STORE" />
      </Helmet>
      <style type="text/css">
        {
          "table th ,table  td{ font-size:1.1rem} label{font-size:1rem !important}"
        }
      </style>

      <div className="page-wrapper">
        <div className="content container-fluid main-container">
          <div className="d-flex justify-content-between">
            <div>
              <button
                onClick={() => navigate(-1)}
                class="btn btn-o ms-1 mb-3"
                style={{
                  background: "#000",
                  color: "#fff",
                  borderRadius: "10px",
                }}
              >
                <i class="fa fa-hand-o-left"></i> Back
              </button>
            </div>
            <div></div>
          </div>
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h3 className="text-start text-dark">Product Entry Receipt Date</h3>
          </div>

          <div
            className="my-4 table-container p-2"
            style={{ background: "white", borderRadius: "10px" }}
          >
            <div className="d-flex justify-content-between align-items-center search-div_store">
              <div className="col-12 col-md-6 col-lg-4">
                <p className="text-start mt-4 fs-6 text-black-50">
                  Show Entries
                  <select
                    onClick={(e) => {
                      setLimit(parseInt(e.target.value));
                    }}
                    className="ms-2 btn-outline-color "
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </p>
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <input
                  className="p-2 input-field w-100"
                  type="text"
                  name="Search"
                  onChange={(e) => handleSearch(e)}
                  placeholder="Search"
                />
              </div>
            </div>
            {!productReceipt ? (
              <NotFoundPage />
            ) : (
              <div className="table-responsive-sm data-table_store">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr className="tableColor">
                      <th colSpan="1">S/N</th>
                      <th colSpan="2">MRR ENTRY DATE</th>
                      <th colSpan="2">MRR ID</th>
                    </tr>
                  </thead>
                  <tbody>
                    {productReceipt.map((item) => (
                      <tr key={counter}>
                        <th className="text-center" colSpan="1">
                          {counter++}
                        </th>
                        <td colSpan="2">
                          {moment(new Date(item.PRODATE)).format("DD-MM-YYYY")}
                        </td>

                        <td colSpan="1" className="text-center py-3">
                          {item.MRR.map((item1) => (
                            <p className="">
                              {item1.MRRNUMBER}
                              <Link
                                to={`/viewproductreceipt/${item1.MRRNUMBER}&${item1.SUP_ID}&${item.PRODATE}`}
                              >
                                <span
                                  style={{
                                    padding: "6px 20px",
                                    borderRadius: "5px",
                                  }}
                                  className="ms-5  text-white   bg-success"
                                >
                                  {" "}
                                  <i className="fa fa-eye fs-6 me-1 "></i>
                                  View
                                </span>
                              </Link>
                              <br />
                            </p>
                          ))}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {search.length > 0 ? (
              <div></div>
            ) : (
              <div className="text-end mt-4 mb-3">
                {pageIndex > 0 && (
                  <button
                    type="button"
                    className="btn btn-outline-color_store px-4 me-2"
                    onClick={() => setPageIndex(pageIndex - 1)}
                  >
                    Previous
                  </button>
                )}

                {productReceipt && productReceipt.length === limit ? (
                  <button
                    type="button"
                    className="btn btn-outline-color_store px-4 me-2"
                    onClick={() => setPageIndex(pageIndex + 1)}
                  >
                    Next
                  </button>
                ) : (
                  ""
                )}
              </div>
            )}
            {/* <div className="text-end mt-4 mb-3">
                {pageIndex > 0 && (
                  <button
                    type="button"
                    className="btn btn-outline-color_store px-4 me-2"
                    onClick={() => setPageIndex(pageIndex - 1)}
                  >
                    Previous
                  </button>
                )}

                {productReceipt && productReceipt.length === limit ? (
                  <button
                    type="button"
                    className="btn btn-outline-color_store px-4 me-2"
                    onClick={() => setPageIndex(pageIndex + 1)}
                  >
                    Next
                  </button>
                ) : (
                  ""
                )}
              </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default MrrProductReceipt;
